import { get } from "lodash";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import ApiService from "utills/ApiService";
import Select from 'react-select';
import { Typography } from "@material-tailwind/react";
import Pagination from "components/wps/Pagination";

const TShirtBoard = (props: any) => {
  const { ticketTab, translate, isMobile, token, eventID, language, setCategory, setTShirtPage, tShirtPage, applyDate, setLoading, category, filter, ticketPlatform } = props;
  const [categories, setCategories] = useState([] as any);
  const [tShirtInfo, setTShirtInfo] = useState([] as any);
  const [tShirtPaging, setTShirtPaging] = useState(null as any);
  const [gender, setGender] = useState('');
  const [tShirtSize, setTShirtSize] = useState(null as any);
  const [tShirtSizeSelected, setTshirtSizeSelected] = useState('');
  const genders = [
    {
      value: '',
      label: translate('all')
    },
    {
      value: 'Nam/ Male',
      label: translate('Nam/ Male')
    },
    {
      value: 'Nữ/ Female',
      label: translate('Nữ/ Female')
    }
  ] as any;


  useEffect(() => {
    if (token && eventID !== '') {
      fetchCategories();
      fetchTShirtSize();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [token, eventID]);

  const fetchCategories = async () => {
    try {
      const result = await ApiService.get(`events/${eventID}/categories`, token);

      if (result && result.length > 0) {
        const arr = [
          {
            value: '',
            label: translate('all')
          }
        ] as any;

        result.forEach((item: any) => {
          const obj = {
            value: item.category_en,
            label: get(item, `category_${language}`, '')
          };

          arr.push(obj);
        });

        setCategories([...arr]);
        setCategory(arr[0]);
        setTShirtPage(1);
      } else {
        setCategories([]);
        setTShirtPage(1);
      }

    } catch (error: any) {
      toast.error(error.message);
    }
  }

  const fetchTShirtSize = async () => {
    try {
      const result = await ApiService.get(`dashboards/orders/${eventID}/t-shirt-sizes`, token);

      if (result && result.length > 0) {
        const arr = [
          {
            value: '',
            label: translate('all')
          }
        ] as any;

        result.forEach((item: any) => {
          const obj = {
            value: item.size_name_en,
            label: item.size_name_en
          };

          arr.push(obj)
        });

        setTShirtSize([...arr]);
      }

    } catch (error: any) {
      toast.error(error.message);
    }
  }

  useEffect(() => {
    if (token && tShirtPage > 0) {
      fetchTShirtInfo();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [tShirtPage, eventID, category, gender, tShirtSizeSelected, applyDate, filter, token]);

  const fetchTShirtInfo = async () => {
    try {
      let cate = (category && category.value) ? category.value : '';
      if (cate && cate !== '') {
        if (cate.includes("&")) {
          cate = cate.replace("&", "%26");
        } else if (cate.includes("+")) {
          cate = cate.replace("+", "%2B");
        }
      }

      const result = await ApiService.get(`dashboards/orders/${eventID}/t-shirt-size/summary/page/${tShirtPage}?limit=10&category=${cate}&gender=${gender}&t_shirt_size=${tShirtSizeSelected}&from_date=${applyDate.start}&to_date=${applyDate.end}&ticket_platform=${ticketPlatform}`, token);

      if (result && result.data) {
        setTShirtPaging(result.paging);
        if (result.data.length > 0) {
          setTShirtInfo(result.data);
        } else {
          setTShirtInfo([]);
        }
      }

    } catch (error: any) {
      toast.error(error.message);
    }
  }

  const handleExportData = async () => {
    setLoading(true);

    try {
      const cate = (category && category.value) ? category.value : '';
      const result = await ApiService.get(`exports/t-shirt-size?category=${cate}&gender=${gender}&t_shirt_size=${tShirtSizeSelected}&from_date=${applyDate.start}&to_date=${applyDate.end}&event_id=${eventID}&ticket_platform=${ticketPlatform}`, token);

      if (result) {
        toast.success(translate('export-success'));
      }
    } catch (error: any) {
      toast.error(error.message);
    }

    setLoading(false);
  }

  if ((tShirtInfo && tShirtSize && tShirtSize.length > 0 && ticketTab === 0)) {
    return (
      <div className={`w-full bg-white ${!isMobile && 'rounded-[8px]'}`}>
        <div className="w-full h-[64px] border-b border-[#e9ecff] flex items-center px-[16px]">
          <div className="text-16 font-700 uppercase">{translate('t-shirt-size-information')}</div>
        </div>

        <div className={`w-full ${!isMobile && 'p-[16px]'}`}>
          <div className={`w-full gap-[12px] flex items-end grid ${isMobile ? 'grid-cols-1 p-[16px] border-b border-[$e9ecff]' : 'grid-cols-4'}`}>
            {
              (categories.length > 0 && category) &&
              <div className="w-full">
                <div className="text-14 font-500 mb-[8px]">{translate('category-event')}</div>

                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={category}
                  name="categories"
                  options={categories}
                  className="text-14"
                  classNamePrefix="select"
                  placeholder={categories[0].label}
                  onChange={(e: any) => {
                    setCategory(e);
                    setTShirtPage(1);
                  }} />
              </div>
            }

            <div className="w-full">
              <div className="text-14 font-500 mb-[8px]">{translate('gender')}</div>

              <Select
                styles={{
                  input: (base) => ({
                    ...base,
                    "input:focus": {
                      boxShadow: "none",
                    },
                  })
                }}
                defaultValue={genders[0]}
                name="categories"
                options={genders}
                className="text-14"
                classNamePrefix="select"
                placeholder={genders[0].label}
                onChange={(e: any) => {
                  setGender(e.value);
                  setTShirtPage(1);
                }} />
            </div>

            {
              (tShirtSize && tShirtSize.length > 0) &&
              <div className="w-full">
                <div className="text-14 font-500 mb-[8px]">{translate('t_shirt_size')}</div>

                <Select
                  styles={{
                    input: (base) => ({
                      ...base,
                      "input:focus": {
                        boxShadow: "none",
                      },
                    })
                  }}
                  defaultValue={tShirtSize[0]}
                  name="categories"
                  options={tShirtSize}
                  className="text-14"
                  classNamePrefix="select"
                  placeholder={tShirtSize[0].label}
                  onChange={(e: any) => {
                    setTshirtSizeSelected(e.value);
                    setTShirtPage(1);
                  }} />
              </div>
            }

            <div className={`${isMobile ? 'w-full' : 'w-[146px]'} flex h-[38px] items-center justify-center rounded-[4px] border-[1px] border-[#A6A1FD] text-[#081774] cursor-pointer`} onClick={handleExportData}>
              <img src="/images/icons/icon-download.svg" className="mr-[4px]" alt="icon-download" />

              <div className="text-[14px]">{translate('export-report')}</div>
            </div>
          </div>

          {
            (tShirtInfo.length > 0 && !isMobile) &&
            <div className="w-full mt-[16px]">
              <table className="w-full min-w-max text-left">
                <thead className="bg-[#e9ecff]">
                  <tr>
                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('no')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('t-shirt-size')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('category-event')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('gender')}
                      </Typography>
                    </th>

                    <th className="p-4">
                      <Typography
                        variant="small"
                        className="text-14 !font-500"
                        placeholder="Typography"
                        onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                        onResizeCapture={() => { }}
                      >
                        {translate('quantity')}
                      </Typography>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {
                    tShirtInfo.length > 0 &&
                    tShirtInfo.map((item: any, index: number) => {
                      const isLast = index === tShirtInfo.length - 1;
                      const classes = isLast ? "p-4" : "p-4 border-b border-blue-gray-50";

                      return (
                        <tr key={`event_${item.code}_${index}`} className="table-row">
                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {(index < 9) && tShirtPaging.current_page - 1}{index + 1}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {item.t_shirt_size}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {get(item, `category_name_${language}`, '')}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {translate(item.gender)}
                            </Typography>
                          </td>

                          <td className={classes}>
                            <Typography
                              variant="small"
                              color="blue-gray"
                              className="font-normal"
                              placeholder="Typography"
                              onPointerEnterCapture="none" onPointerLeaveCapture="none" onResize={() => { }}
                              onResizeCapture={() => { }}
                            >
                              {item.quantity}
                            </Typography>
                          </td>
                        </tr>
                      );
                    })}
                </tbody>
              </table>

              {
                tShirtPaging &&
                <div className={`board__bottom ${isMobile ? 'mt-[16px]' : 'pagination-desktop'}`}>
                  {
                    tShirtPaging.total_page > 1 &&
                    <Pagination
                      setPage={setTShirtPage}
                      paging={tShirtPaging}
                    />
                  }
                </div>
              }
            </div>
          }

          {
            (tShirtInfo.length > 0 && isMobile) &&
            <div className={`w-full grid grid-cols-1 gap-[16px] bg-[#f6f5fe] ${!isMobile ? 'p-[16px]' : 'px-[16px] pt-[16px]'}`}>
              {
                tShirtInfo.length > 0 &&
                tShirtInfo.map((item: any, index: number) => {
                  return (
                    <div className="w-full p-[16px] rounded-[8px] bg-white grid grid-cols-1 gap-[12px]" key={`t_shirt_item_${index}`}>
                      <div className="w-full flex items-start justify-between text-14">
                        <div className="w-[100px] font-500">{translate('no')}</div>
                        <div className="flex-1">{(index < 9) && tShirtPaging.current_page - 1}{index + 1}</div>
                      </div>

                      <div className="w-full flex items-start justify-between text-14">
                        <div className="w-[100px] font-500">{translate('t-shirt-size')}</div>
                        <div className="flex-1">{item.t_shirt_size}</div>
                      </div>

                      <div className="w-full flex items-start justify-between text-14">
                        <div className="w-[100px] font-500">{translate('category-event')}</div>
                        <div className="flex-1">{get(item, `category_name_${language}`)}</div>
                      </div>

                      <div className="w-full flex items-start justify-between text-14">
                        <div className="w-[100px] font-500">{translate('gender')}</div>
                        <div className="flex-1">{translate(item.gender)}</div>
                      </div>

                      <div className="w-full flex items-start justify-between text-14">
                        <div className="w-[100px] font-500">{translate('quantity')}</div>
                        <div className="flex-1">{item.quantity}</div>
                      </div>
                    </div>
                  )
                })
              }

              {
                tShirtPaging &&
                <div className="board__bottom">
                  {
                    tShirtPaging.total_page > 1 &&
                    <Pagination
                      setPage={setTShirtPage}
                      paging={tShirtPaging}
                    />
                  }
                </div>
              }
            </div>
          }

        </div>
      </div>
    )
  } else {
    return <></>
  }
};

export default TShirtBoard;